import { render } from "./ImportTrainees.vue?vue&type=template&id=58e9e5ca&scoped=true"
import script from "./ImportTrainees.vue?vue&type=script&lang=js"
export * from "./ImportTrainees.vue?vue&type=script&lang=js"

import "./ImportTrainees.vue?vue&type=style&index=0&id=58e9e5ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e9e5ca"]])

export default __exports__